import { strapiFetch } from './strapiClient';
import { toPopulateQuery } from './utils';

const FOOTER_POPULATE = {
  brandImage: true,
  columns: {
    links: {
      iconImage: true,
    },
  },
  brandBadge: {
    logo: true,
  },
};

export const getFooter = () => {
  const query = toPopulateQuery(FOOTER_POPULATE);
  return strapiFetch(`/api/site-footer?${query}`);
};